import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessagesSquare } from "lucide-react";
import { api, fileUrl, fmtDateTime } from "../lib/api";
import { Screen, PageHeader, Empty } from "../components/ui-kit";
import RoleBadge from "../components/RoleBadge";

const Avatar = ({ path, picture, name }) => (
  <img src={fileUrl(path) || picture || `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=1a1424&color=D4AF37`} alt="" className="w-12 h-12 rounded-full object-cover border border-white/10" />
);

export default function Messages() {
  const navigate = useNavigate();
  const [convos, setConvos] = useState([]);

  useEffect(() => { api.get("/conversations").then((r) => setConvos(r.data)).catch(() => {}); }, []);

  return (
    <Screen>
      <PageHeader overline="Community" title="Messages" back />
      {convos.length === 0 ? (
        <Empty icon={MessagesSquare} text="No conversations yet. Add friends to start chatting." />
      ) : (
        <div className="space-y-2">
          {convos.map((c) => (
            <button key={c.friend.id} data-testid={`convo-${c.friend.id}`} onClick={() => navigate(`/messages/${c.friend.id}`)}
              className="w-full flex items-center gap-3 rounded-2xl bg-white/5 border border-white/10 p-3 text-left active:scale-[0.99] transition-transform hover:bg-white/[0.07]">
              <Avatar path={c.friend.avatar_path} picture={c.friend.picture} name={c.friend.name} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <p className="font-medium truncate flex items-center gap-1.5">{c.friend.name} <RoleBadge role={c.friend.role} size="xs" /></p>
                  {c.last_message && <span className="text-[#A19DB0]/60 text-[11px] shrink-0">{fmtDateTime(c.last_message.created_at)}</span>}
                </div>
                <p className="text-[#A19DB0] text-sm truncate mt-0.5">{c.last_message ? c.last_message.text : "Say hello 👋"}</p>
              </div>
              {c.unread > 0 && <span data-testid={`unread-${c.friend.id}`} className="shrink-0 min-w-5 h-5 px-1.5 rounded-full bg-[#D4AF37] text-black text-xs font-bold flex items-center justify-center">{c.unread}</span>}
            </button>
          ))}
        </div>
      )}
    </Screen>
  );
}
